// src/Pages/Home.js
import React from 'react';
// import HeroSection from '../Components/HeroSection';
import HeroSection from '../Components/HeroSection2';
import CategoryFilter from '../Components/CategoryFilter';
import RestaurantSection from '../Components/RestaurantSection';
import ContactSection from '../Components/ContactSection';
import SuggestedSection from '../Components/Suggested';
import StoresSection from '../Components/Stores';
import WelcomeInfoSection from '../Components/WelcomeInfo';

// import HorizontalMenu from '../Components/HorizontalMenu';


const Home = () => {
  return (
    <div className="">
      {/* <HorizontalMenu /> */}

      <HeroSection />
      
      <CategoryFilter />
      <SuggestedSection/>
      <StoresSection/>
      {/* <WelcomeInfoSection/> */}
      
      <ContactSection />
    </div>
  );
};

export default Home;
